import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import CmsContent from '../components/CmsContent'; 
import axios from 'axios'; 

import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import { base_url} from '../common/Constants';
import withRouter from '../components/withRouter';
 
class Cms extends React.Component{

    constructor(props){
        super(props); 

        this.state = { 
            loading:1,
            content:"",
        }
    }

     componentDidMount()
    {
        var slugs = {"quality-policy" : 10, "hse-policy" : 11, "environmental-policy": 12, "director-message" : 13}

       var slug = slugs[this.props.params.slug];
       var cms = JSON.parse(localStorage.getItem("content"));
       this.setState({content:cms[slug]});  
       this.setState({loading:0});  
    }

     componentDidUpdate(prevProps)
    {
        if(this.props.params.slug !== prevProps.params.slug)
        {
           var slugs = {"quality-policy" : 10, "hse-policy" : 11, "environmental-policy": 12 , "director-message" : 13}

            var slug = slugs[this.props.params.slug];
            var cms = JSON.parse(localStorage.getItem("content"));
            this.setState({content:cms[slug]});  
            this.setState({loading:0});  
        }
    }
 
    render()
    {
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));

          if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
        return (
            <div className="page-wrapper">
                <Header/> 
                <Helmet>
                    <title>{metas[1].title}</title>  
                    <meta name="description" content={metas[1].meta_description} />
                    <meta name="keywords" content={metas[1].meta_title} />
                    <meta property="og:image" content={content[5].image}  />
                    <link rel="canonical" href={base_url+'about-us'} />
                </Helmet>
                <PageHeader title={this.state.content.title || ""}  banner="About"/>
                <CmsContent content={this.state.content}/>  
                <Footer/>
            </div>
       
        )
    }

}
export default withRouter(Cms);